"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
/**
 * Tabular report view value formatter.
 */
var CellValueFormatter = /** @class */ (function () {
    function CellValueFormatter(reportViewStyles, localeService, localeInfo) {
        this.reportViewStyles = reportViewStyles;
        this.localeService = localeService;
        this.localeInfo = localeInfo;
        /**
         * Cache RegExp. to fix decimal places.
         * @type {Map<any, any>}
         * @private
         */
        this._decimalPlacesRegExp = new Map();
        /**
         * Cache RegExp to format numbers with whole and decimal parts.
         * @type {Map<any, any>}
         * @private
         */
        this._wholePartRegExp = new Map();
    }
    /**
     * Format value.
     * @param value original value
     * @param {number} columnBranchIndex column branch index
     * @param {number} languageId current language ID
     * @param measureType
     * @param measureTypeObject
     * @returns {string}
     */
    CellValueFormatter.prototype.formatValue = function (value, columnBranchIndex, languageId, measureType, measureTypeObject, localeInfo) {
        if (value === null || value === undefined) {
            return value;
        }
        var numberValue = +value;
        if (this.localeService && !isNaN(numberValue)) {
            switch (measureType) {
                case idm_dataset_service_client_js_1.MeasurePathType.DATE: {
                    value = this.localeService.formatDateByLocale(numberValue, this.localeInfo);
                    break;
                }
                case idm_dataset_service_client_js_1.MeasurePathType.DATETIME: {
                    value = this.localeService.formatDateTimeByLocale(numberValue, this.localeInfo);
                    break;
                }
            }
        }
        if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle) {
            var measureValueFormatDto = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle.measureValueFormat;
            if ((measureType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER || measureType === idm_dataset_service_client_js_1.MeasurePathType.MONEY) && !isNaN(value)) {
                value = Number(value);
                value = this.applyNumberShowFormat(value, measureValueFormatDto);
                var numberFormat = localeInfo.numberFormat;
                if (measureValueFormatDto.formattingPattern) {
                    var patternParts = measureValueFormatDto.formattingPattern.split('.');
                    var decimalPlaces = patternParts.length > 1 ? patternParts[1].length : 0;
                    value = this.formatNumber(value, 3, decimalPlaces, numberFormat.groupSeparator, numberFormat.decimalSeparator);
                }
                else {
                    value = this.localeService.formatNumberByLocale(value, localeInfo);
                }
            }
            if (measureType === idm_dataset_service_client_js_1.MeasurePathType.MONEY) {
                value = measureTypeObject['symbol'] + value;
            }
            if (value && measureValueFormatDto.prefixText != null && measureValueFormatDto.prefixText.getValue(languageId) != null) {
                value = measureValueFormatDto.prefixText.getValue(languageId) + value;
            }
            if (value && measureValueFormatDto.suffixText != null && measureValueFormatDto.suffixText.getValue(languageId) != null) {
                value = value + measureValueFormatDto.suffixText.getValue(languageId);
            }
            if (value && measureValueFormatDto && measureValueFormatDto.isShowInPercentage) {
                if (value && value !== '') {
                    value = value + '%';
                }
            }
        }
        return value;
    };
    CellValueFormatter.prototype.formatRowGroupingCaption = function (values, firstRowBranchPathIds, languageId) {
        var _this = this;
        var result = values.join(' / ');
        if (this.reportViewStyles.rowBranchStylesDto && this.reportViewStyles.rowBranchStylesDto[0]) {
            result = '';
            firstRowBranchPathIds.forEach(function (id, index) {
                if (result.length >= 1) {
                    result += ' / ';
                }
                if (_this.reportViewStyles.rowBranchStylesDto[0].categoriesStyle.get(id)) {
                    var reference = _this.reportViewStyles.rowBranchStylesDto[0].categoriesStyle.get(id).reference;
                    var alias = _this.reportViewStyles.rowBranchStylesDto[0].categoriesStyle.get(id).alias;
                    if (alias && alias.getValue(languageId)) {
                        result += alias.getValue(languageId);
                    }
                    else {
                        result += values[index];
                    }
                    // TODO: Referenced will be implemented later
                    // result = this.appendReferenceNumber(result, reference, languageId);
                }
            });
        }
        return result;
    };
    /**
     * Returns column header category element title.
     * @param {string} title original title
     * @param {number} columnBranchIndex
     * @param {number} columnCategoryPathHolderId
     * @param {number} languageId
     * @returns {string}
     */
    CellValueFormatter.prototype.getColumnCategoryTitle = function (title, columnBranchIndex, columnCategoryPathHolderId, languageId) {
        if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[columnBranchIndex]) {
            if (this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].categoriesStyle.get(columnCategoryPathHolderId)) {
                var reference = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].categoriesStyle.get(columnCategoryPathHolderId).reference;
                var alias = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].categoriesStyle.get(columnCategoryPathHolderId).alias;
                if (alias && alias.getValue(languageId)) {
                    title = alias.getValue(languageId);
                }
                // TODO: Referenced will be implemented later
                // title = this.appendReferenceNumber(title, reference, languageId);
            }
        }
        return title;
    };
    /**
     * Returns column header measure element title.
     * @param {string} title original title
     * @param {number} columnBranchIndex
     * @param {number} languageId
     * @returns {string}
     */
    CellValueFormatter.prototype.getColumnMeasureTitle = function (title, columnBranchIndex, languageId) {
        if (this.reportViewStyles.columnBranchStylesDto && this.reportViewStyles.columnBranchStylesDto[columnBranchIndex]) {
            if (this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle) {
                var reference = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle.reference;
                var alias = this.reportViewStyles.columnBranchStylesDto[columnBranchIndex].measureStyle.alias;
                if (alias && alias.getValue(languageId)) {
                    title = alias.getValue(languageId);
                }
                // TODO: Referenced will be implemented later
                // title = this.appendReferenceNumber(title, reference, languageId);
            }
        }
        return title;
    };
    /**
     * Formats number
     * @param value value to format
     * @param decimalPlaces: length of decimal
     * @param wholePart: length of whole part
     * @param sectionsDelimiter: sections delimiter
     * @param decimalDelimiter: decimal delimiter
     */
    CellValueFormatter.prototype.formatNumber = function (value, wholePart, decimalPlaces, sectionsDelimiter, decimalDelimiter) {
        if (wholePart === void 0) { wholePart = 3; }
        if (sectionsDelimiter === void 0) { sectionsDelimiter = ','; }
        // const num = value.toFixed(Math.max(0, ~~decimalPlaces)); //rounds
        var num;
        if (decimalPlaces === 0) {
            num = Math.round(value).toString();
        }
        else {
            num = Number(value.toFixed(decimalPlaces)).toString();
            num = num.match(this.getDecimalPlacesRegExp(decimalPlaces))[0];
        }
        var isDecimalPointPresent = num.indexOf('.') > -1;
        return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num)
            .replace(this.getWholePartRegExp(wholePart, !isDecimalPointPresent ? 0 : decimalPlaces), '$&' + sectionsDelimiter);
    };
    CellValueFormatter.prototype.getDecimalPlacesRegExp = function (decimalPlaces) {
        if (!this._decimalPlacesRegExp.has(decimalPlaces)) {
            this._decimalPlacesRegExp.set(decimalPlaces, new RegExp("^-?\\d+(?:\\.\\d{0," + decimalPlaces + "})?"));
        }
        return this._decimalPlacesRegExp.get(decimalPlaces);
    };
    CellValueFormatter.prototype.getWholePartRegExp = function (wholePart, decimalPlaces) {
        var key = wholePart + "_" + decimalPlaces;
        if (!this._wholePartRegExp.has(key)) {
            var re = '\\d(?=(\\d{' + wholePart + '})+' + (decimalPlaces > 0 ? '\\D' : '$') + ')';
            this._wholePartRegExp.set(key, new RegExp(re, 'g'));
        }
        return this._wholePartRegExp.get(key);
    };
    /**
     * Append reference number to text
     * @returns {string}
     */
    CellValueFormatter.prototype.appendReferenceNumber = function (text, reference, languageId) {
        if (reference) {
            var referenceNumber = +reference.referenceNumber.text.getValue(languageId);
            text += "<sup style='vertical-align: super'>" + referenceNumber + "</sup>";
        }
        return text;
    };
    CellValueFormatter.prototype.applyNumberShowFormat = function (value, measureValueFormatDto) {
        if (measureValueFormatDto.numberShowFormat && measureValueFormatDto.numberShowFormat !== idm_report_export_service_client_js_1.NumberShowFormat.SHOW_IN_ORIGINAL) {
            value = Number(value) / measureValueFormatDto.numberShowFormat;
        }
        return value;
    };
    return CellValueFormatter;
}());
exports.CellValueFormatter = CellValueFormatter;
//# sourceMappingURL=cell-value-formatter.js.map